// Numbers of the seller workspace. An unknown is the word, never 0: a count nobody could read or a
// seller with no matched store must not look like an empty store.

export const unknownText = (t) => t('sellers_workspace.unknown', 'bilinmiyor');

export const formatCount = (value, t) =>
    (value === null || value === undefined) ? unknownText(t) : Number(value).toLocaleString('tr-TR');

export const formatGap = (value, t) => {
    if (value === null || value === undefined) return unknownText(t);
    const sign = value > 0 ? '+' : (value < 0 ? '−' : '');
    return `${sign}%${Math.abs(value).toLocaleString('tr-TR', {maximumFractionDigits: 1})}`;
};

// The API sends naive UTC timestamps.
export const formatTime = (value) => {
    if (!value) return '—';
    const text = String(value);
    const date = new Date(/(Z|[+-]\d\d:?\d\d)$/.test(text) ? text : text + 'Z');
    return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString('tr-TR');
};
